import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';

const ROLE_LABELS: Record<string, string> = {
  platform_admin: 'Платформ админ', director: 'Захирал', manager: 'Менежер', guard: 'Харуул', accountant: 'Нягтлан',
};

export default function AdminUsersPage() {
  const { user } = useAuth();
  const isPlatform = user?.role === 'platform_admin';
  const [users, setUsers] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [tenantFilter, setTenantFilter] = useState('');
  const [tenantOptions, setTenantOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const PAGE_SIZE = 20;
  const [form, setForm] = useState({ email: '', first_name: '', last_name: '', role: 'manager', password: 'changeme123' });
  const [invForm, setInvForm] = useState({ email: '', role: 'manager', first_name: '', last_name: '' });
  const [showInvite, setShowInvite] = useState(false);
  const [invitations, setInvitations] = useState<any[]>([]);
  const [inviteResult, setInviteResult] = useState<string | null>(null);
  const [separateUser, setSeparateUser] = useState<any | null>(null);
  const [sepForm, setSepForm] = useState({ org_name: '', registration_number: '', contact_phone: '', district: '' });

  const load = () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.set('skip', String(page * PAGE_SIZE));
    params.set('limit', String(PAGE_SIZE));
    if (search) params.set('search', search);
    if (roleFilter) params.set('role', roleFilter);
    if (tenantFilter) params.set('tenant_id', tenantFilter);
    Promise.all([
      api.get(`/admin/users?${params.toString()}`).then(res => { setUsers(res?.items || []); setTotal(res?.total || 0); }).catch(() => {}),
      api.get('/admin/invitations').then(res => setInvitations(res?.items || [])).catch(() => {}),
    ]).finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [page, search, roleFilter, tenantFilter]);

  useEffect(() => {
    if (isPlatform) {
      api.get('/admin/users/tenants').then(res => setTenantOptions(res?.items || [])).catch(() => {});
    }
  }, [isPlatform]);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/admin/users', form);
    setShowForm(false);
    setForm({ email: '', first_name: '', last_name: '', role: 'manager', password: 'changeme123' });
    load();
  };

  const handleInvite = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await api.post('/admin/invitations', invForm);
    setInviteResult(res.demo_link || res.invitation_token);
    setInvForm({ email: '', role: 'manager', first_name: '', last_name: '' });
    load();
  };

  const toggleActive = async (u: any) => {
    await api.put(`/admin/users/${u.id}`, { is_active: !u.is_active });
    load();
  };

  // Backend-ийн эрхийн дүрэмтэй тааруулсан: платформ админ бүгдийг, захирал
  // зөвхөн өөрийн СӨХ-ийн захирал бус хэрэглэгчийг сэргээнэ. Өөрийгөө үгүй.
  const canResetPassword = (u: any) => {
    // Өөрийгөө сэргээхийг нуух (backend ч мөн 400-аар хаана).
    if (u.id === (user as any)?.id || u.id === (user as any)?.user_id) return false;
    if (u.role === 'platform_admin') return false;
    if (isPlatform) return true;
    return user?.role === 'director' && u.role !== 'director';
  };

  const handleResetPassword = async (u: any) => {
    const name = `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email;
    if (!window.confirm(`${name}-н нууц үгийг сэргээх үү?\n\nШинэ түр нууц үг үүсч, ${u.email} рүү имэйлээр илгээгдэнэ.`)) return;
    try {
      const res = await api.post(`/admin/users/${u.id}/reset-password`, {});
      const mailNote = res?.email_sent
        ? `\n\n${u.email} рүү имэйл илгээгдлээ.`
        : `\n\n⚠️ Имэйл илгээгдсэнгүй — доорх нууц үгийг хэрэглэгчид өөрөө дамжуулна уу.`;
      window.prompt(`Шинэ түр нууц үг:${mailNote}\n\n(Хуулж авна уу)`, res?.temp_password || '');
    } catch (e: any) {
      alert(e?.body ? JSON.parse(e.body)?.detail || 'Алдаа гарлаа' : 'Алдаа гарлаа');
    }
  };

  const handleSeparate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!separateUser) return;
    try {
      const res = await api.post(`/admin/users/${separateUser.id}/separate-tenant`, sepForm);
      alert(res.message || 'Амжилттай');
      setSeparateUser(null);
      setSepForm({ org_name: '', registration_number: '', contact_phone: '', district: '' });
      load();
    } catch (err: any) {
      alert(err?.body ? JSON.parse(err.body)?.detail || 'Алдаа' : 'Алдаа');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Хэрэглэгч удирдлага</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { setShowInvite(!showInvite); setShowForm(false); }} style={btnSecondary}>
            {showInvite ? 'Болих' : '✉ Урилга илгээх'}
          </button>
          <button onClick={() => { setShowForm(!showForm); setShowInvite(false); }} style={btnPrimary}>
            {showForm ? 'Болих' : '+ Шинэ хэрэглэгч'}
          </button>
        </div>
      </div>

      {showInvite && (
        <div style={card}>
          <h3 style={{ marginBottom: 16, fontSize: 16 }}>Урилга илгээх</h3>
          <form onSubmit={handleInvite} style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
            <div>
              <label style={labelStyle}>И-мэйл</label>
              <input value={invForm.email} onChange={e => setInvForm({ ...invForm, email: e.target.value })} style={inputStyle} required />
            </div>
            <div>
              <label style={labelStyle}>Эрх</label>
              <select value={invForm.role} onChange={e => setInvForm({ ...invForm, role: e.target.value })} style={inputStyle}>
                <option value="manager">Менежер</option>
                <option value="director">Захирал</option>
                <option value="guard">Харуул</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Нэр</label>
              <input value={invForm.first_name} onChange={e => setInvForm({ ...invForm, first_name: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Овог</label>
              <input value={invForm.last_name} onChange={e => setInvForm({ ...invForm, last_name: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <button type="submit" style={btnPrimary}>Урилга илгээх</button>
            </div>
          </form>
          {inviteResult && (
            <div style={{ marginTop: 12, padding: 12, background: '#ecfdf5', borderRadius: 6, fontSize: 13 }}>
              Урилга илгээгдсэн! Линк: <code>{inviteResult}</code>
            </div>
          )}
        </div>
      )}

      {showForm && (
        <div style={card}>
          <h3 style={{ marginBottom: 16, fontSize: 16 }}>Шинэ хэрэглэгч</h3>
          <form onSubmit={handleCreate} style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
            <div>
              <label style={labelStyle}>И-мэйл</label>
              <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={inputStyle} required />
            </div>
            <div>
              <label style={labelStyle}>Эрх</label>
              <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} style={inputStyle}>
                <option value="manager">Менежер</option>
                <option value="director">Захирал</option>
                <option value="guard">Харуул</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Нэр</label>
              <input value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Овог</label>
              <input value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Нууц үг</label>
              <input value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <button type="submit" style={btnPrimary}>Үүсгэх</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <>
          <div style={card}>
            <h3 style={{ marginBottom: 16 }}>Хэрэглэгчид ({total})</h3>

            {/* Filters */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
              <input
                value={searchInput}
                onChange={e => setSearchInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { setPage(0); setSearch(searchInput.trim()); } }}
                placeholder="Нэр, и-мэйл хайх..."
                style={{ ...inputStyle, maxWidth: 240, marginBottom: 0 }}
              />
              <button onClick={() => { setPage(0); setSearch(searchInput.trim()); }} style={{ ...btnPrimary, padding: '8px 16px' }}>Хайх</button>
              <select value={roleFilter} onChange={e => { setPage(0); setRoleFilter(e.target.value); }} style={{ ...inputStyle, maxWidth: 160, marginBottom: 0 }}>
                <option value="">Бүх эрх</option>
                <option value="director">Захирал</option>
                <option value="manager">Менежер</option>
                <option value="guard">Харуул</option>
              </select>
              {isPlatform && (
                <select value={tenantFilter} onChange={e => { setPage(0); setTenantFilter(e.target.value); }} style={{ ...inputStyle, maxWidth: 200, marginBottom: 0 }}>
                  <option value="">Бүх СӨХ</option>
                  {tenantOptions.map((t: any) => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              )}
              {(search || roleFilter || tenantFilter) && (
                <button onClick={() => { setPage(0); setSearch(''); setSearchInput(''); setRoleFilter(''); setTenantFilter(''); }}
                  style={{ background: 'none', border: 'none', color: '#236844', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Цэвэрлэх</button>
              )}
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>И-мэйл</th>
                  <th style={th}>Нэр</th>
                  {isPlatform && <th style={th}>СӨХ</th>}
                  <th style={th}>Эрх</th>
                  <th style={th}>Статус</th>
                  <th style={th}>Эрх нээгдсэн</th>
                  <th style={th}>Сүүлд нэвтэрсэн</th>
                  <th style={th}>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u: any) => (
                  <tr key={u.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}>{u.email}</td>
                    <td style={td}>{u.first_name} {u.last_name}</td>
                    {isPlatform && <td style={td}>{u.tenant_name || '-'}</td>}
                    <td style={td}>
                      <span style={{ background: '#dcfce7', color: '#236844', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                        {ROLE_LABELS[u.role] || u.role}
                      </span>
                    </td>
                    <td style={td}>
                      <span style={{
                        background: u.is_active ? '#dcfce7' : '#fee2e2',
                        color: u.is_active ? '#16a34a' : '#dc2626',
                        padding: '2px 8px', borderRadius: 4, fontSize: 12,
                      }}>{u.is_active ? 'Идэвхтэй' : 'Идэвхгүй'}</span>
                    </td>
                    <td style={td}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '-'}</td>
                    <td style={td}>{u.last_login_at ? new Date(u.last_login_at).toLocaleDateString() : '-'}</td>
                    <td style={td}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button onClick={() => toggleActive(u)} style={{
                          background: u.is_active ? '#fee2e2' : '#dcfce7',
                          color: u.is_active ? '#dc2626' : '#16a34a',
                          border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                        }}>{u.is_active ? 'Идэвхгүй болгох' : 'Идэвхжүүлэх'}</button>
                        <button onClick={() => setSeparateUser(u)} style={{
                          background: '#eff6ff', color: '#2563eb',
                          border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                        }}>Тусдаа СӨХ</button>
                        {canResetPassword(u) && (
                          <button onClick={() => handleResetPassword(u)} style={{
                            background: '#fef3c7', color: '#b45309',
                            border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                          }}>Нууц үг сэргээх</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {total > PAGE_SIZE && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 16 }}>
                <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0}
                  style={{ ...btnPrimary, padding: '6px 14px', opacity: page === 0 ? 0.4 : 1 }}>← Өмнөх</button>
                <span style={{ fontSize: 14, color: '#5f6f66' }}>{page + 1} / {Math.max(1, Math.ceil(total / PAGE_SIZE))}</span>
                <button onClick={() => setPage(p => p + 1)} disabled={(page + 1) * PAGE_SIZE >= total}
                  style={{ ...btnPrimary, padding: '6px 14px', opacity: (page + 1) * PAGE_SIZE >= total ? 0.4 : 1 }}>Дараах →</button>
              </div>
            )}
          </div>

          {invitations.length > 0 && (
            <div style={{ ...card, marginTop: 16 }}>
              <h3 style={{ marginBottom: 16 }}>Хүлээгдэж буй урилгууд ({invitations.length})</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                    <th style={th}>И-мэйл</th>
                    <th style={th}>Нэр</th>
                    <th style={th}>Эрх</th>
                    <th style={th}>Огноо</th>
                  </tr>
                </thead>
                <tbody>
                  {invitations.map((inv: any) => (
                    <tr key={inv.token} style={{ borderBottom: '1px solid #e8e5dc' }}>
                      <td style={td}>{inv.email}</td>
                      <td style={td}>{inv.first_name} {inv.last_name}</td>
                      <td style={td}>{ROLE_LABELS[inv.role] || inv.role}</td>
                      <td style={td}>{new Date(inv.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {separateUser && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setSeparateUser(null)}>
          <div style={{ ...card, width: 440, maxWidth: '90%' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 8px', fontFamily: "'Inter'", color: '#1c2b22' }}>
              Тусдаа СӨХ болгох
            </h3>
            <p style={{ fontSize: 13, color: '#5f6f66', marginBottom: 16 }}>
              {separateUser.email} хэрэглэгчийг шинэ СӨХ-д захирлаар шилжүүлнэ.
            </p>
            <form onSubmit={handleSeparate}>
              <div style={{ marginBottom: 12 }}>
                <label style={labelStyle}>СӨХ нэр *</label>
                <input value={sepForm.org_name} onChange={e => setSepForm({ ...sepForm, org_name: e.target.value })} style={inputStyle} required placeholder="Шинэ СӨХ нэр" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label style={labelStyle}>Регистрийн дугаар</label>
                  <input value={sepForm.registration_number} onChange={e => setSepForm({ ...sepForm, registration_number: e.target.value })} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Утас</label>
                  <input value={sepForm.contact_phone} onChange={e => setSepForm({ ...sepForm, contact_phone: e.target.value })} style={inputStyle} />
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Дүүрэг</label>
                <select value={sepForm.district} onChange={e => setSepForm({ ...sepForm, district: e.target.value })} style={inputStyle}>
                  <option value="">Сонгоно уу</option>
                  {['Баянгол','Баянзүрх','Сонгинохайрхан','Хан-Уул','Сүхбаатар','Чингэлтэй','Налайх','Багануур','Багахангай'].map(d =>
                    <option key={d} value={d}>{d}</option>
                  )}
                </select>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="submit" style={btnPrimary}>Шилжүүлэх</button>
                <button type="button" onClick={() => setSeparateUser(null)} style={btnSecondary}>Болих</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const btnSecondary: React.CSSProperties = {
  background: '#e8e5dc', color: '#2a3b32', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14,
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
